$(function() {
  $("#update-cart").attr("disabled", "disabled");
  $("#cart_check_f, #cart_check_s, #cart_check_n").click(function() {
    if (
      $("#cart_check_f").prop("checked") &&
      $("#cart_check_s").prop("checked") &&
      $("#cart_check_n").prop("checked")
    ) {
      $("#update-cart").removeAttr("disabled");
    } else {
      $("#update-cart").attr("disabled", "disabled");
    }
  });
});

